import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { FormatAmount } from "@portal/helpers";
import { IMoneyResultProps } from "../types";

export const MoneyResultOverview = ({
  title,
  isDefaultLanguage,
  managementFee,
  depotFee,
  summedFee,
  totalValueAfterCost,
  portfolioValue,
}: IMoneyResultProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col w-full p-2 border rounded-md bg-white">
      <div className="flex w-full flex-row justify-between">
        <Typography variant="Bold">{title}</Typography>
        <Typography variant="Bold">{texts.PAGE_15_PRICE}</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_EXPECTED_VALUE_BEFORE_COST}</Typography>
        <Typography>{FormatAmount(portfolioValue)},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_COMMISIONER}</Typography>
        <Typography>{FormatAmount(managementFee ?? 0)},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_TRANSACTION_COST}</Typography>
        <Typography>{0},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_COST_BANK}</Typography>
        <Typography>{FormatAmount(depotFee ?? 0)},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_TOTAL_COST}</Typography>
        <Typography>{FormatAmount(summedFee ?? 0)},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_EXPECTED_VALUE}</Typography>
        <Typography>{FormatAmount(totalValueAfterCost)},-</Typography>
      </div>
    </div>
  );
};
